import { useComments } from '../queries/useComments.js'
import { useUIStore } from '../store/uiStore.js'

/**
 * CommentBubble — click to open the comment panel for this context
 * (goal or sub-goal). Shows a live count of OPEN (unresolved) thread
 * replies, and highlights amber when there are open threads.
 */
export default function CommentBubble({ label, type = 'Goal' }) {
  const { openReplyCount, openThreadCount } = useComments(label)
  const openPanel = useUIStore((s) => s.openCommentPanel)
  const hasOpen = openThreadCount > 0

  return (
    <span
      data-tour="comment-bubble"
      onClick={(e) => {
        e.stopPropagation()
        openPanel({ label, type })
      }}
      title={
        hasOpen
          ? `${openThreadCount} open thread${openThreadCount > 1 ? 's' : ''} · ${openReplyCount} ${openReplyCount === 1 ? 'message' : 'messages'}`
          : 'Add a comment'
      }
      style={{
        background: hasOpen ? '#fef3c7' : '#f3f4f6',
        color: hasOpen ? '#b45309' : 'var(--muted-light)',
        border: `1px solid ${hasOpen ? '#fde68a' : '#e5e7eb'}`,
        borderRadius: 12,
        padding: '0 5px',
        fontSize: 10,
        fontWeight: 700,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        transition: 'all 0.15s',
        userSelect: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        lineHeight: '16px',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = hasOpen ? '#fde68a' : '#e5e7eb'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = hasOpen ? '#fef3c7' : '#f3f4f6'
      }}
    >
      💬{hasOpen ? ` ${openReplyCount}` : ''}
    </span>
  )
}
